/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import TextInput from 'components/input/textInput';
import DropDownInput from 'components/input/DropDownInput';
import { useHistory } from 'react-router';
import { routers } from 'router/router';
import { useAppDispatch } from 'app/hooks';
import { getAccessToken, getUserId, getUserRole, removeAccessToken, removeUserId } from 'utils/sessionStorage';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import { USER_ROLE } from 'constants/common';

const supportedStudentOptions = [
    { name: 'Select range', value: ''},
    { name: '1-10 students', value: '1-10'},
    { name: '11-25 students', value: '11-25'},
    { name: '26-50 students', value: '26-50'},
    { name: '51-100 students', value: '51-100'},
    { name: '101-250 students', value: '101-250'},
    { name: '250+ students', value: '250+'},
];

interface Props {
  onNextStep: (step: string) => void;
  formik: any;
}
  
//step === '3c'
const FormCounselorSetup = ({ formik, onNextStep }: Props) => {
    let history = useHistory();
    const dispatch:any = useAppDispatch();
    let studentId = getUserId();
    let token = getAccessToken();

    const handleLogout = () => {
        dispatch(logout());
        removeAccessToken();
        removeUserId();
        history.push(routers.login.path);
    };
    
    const handleGotoDashboard = async () => {
      history.push({
        pathname: routers.dashBoard.path,
        search: `?role=${getUserRole() || formik.values.user_role}`,
      });
    }
    const handleSkip = async (e:any) => {
        e.preventDefault();
        e.stopPropagation();
        onNextStep('phone');
    }

    // React.useEffect(() => {
    //     token = getAccessToken();
    //     console.log('token', token);
    //     if (!token) {
    //         // force redirect to login page
    //         handleLogout();
    //         return;
    //     }
    //     // if (formik.values.user_role !== USER_ROLE.counselor) {
    //     //     // force redirect to login page
    //     //     handleLogout();
    //     // }
    //     // if (!token || formik.values.user_role !== USER_ROLE.counselor) {
    //     //     // force redirect to login page
    //     //     handleLogout();
    //     // }
    // }, []);
 
    return (
    <div className="min-h-screen flex items-center justify-center p-0 mb-5 px-md-5 container">
        <div className="w-full max-w-2xl">
            <div className="text-center mb-8 mt-8">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-gradmap-blue rounded-2xl mb-6">
                    <i className="text-white text-3xl" data-fa-i2svg="">
                      <svg className="svg-inline--fa-24px fa-chalkboard-user" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chalkboard-user" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" data-fa-i2svg=""><path fill="currentColor" d="M160 64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H336.8c-11.8-25.5-29.9-47.5-52.4-64H384V320c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v32h64V64L224 64v49.1C205.2 102.2 183.3 96 160 96V64zm0 64a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM133.3 352h53.3C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3C0 411.7 59.7 352 133.3 352z"></path></svg>
                    </i>
                </div>
                <h1 className="text-4xl font-bold text-gray-900 mb-3">Set up your counselor workspace</h1>
                <p className="text-lg text-gray-600">Tell us a bit about your practice to personalize your experience</p>
            </div>

            <div id="setup-form" className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8">
                <div className="row">
                  <div className="col-md-12">
                    <TextInput
                        label={'Organization or practice name'}
                        labelClass="block text-sm font-medium text-gray-700 mb-2"
                        labelCustom={(<span className="text-gray-500 font-normal">(optional)</span>)}
                        placeholder="e.g., Lincoln High School, College Planning Associates"
                        name={'school_or_organization_work_with'}
                        values={formik.values.school_or_organization_work_with}
                        onChange={formik.handleChange}
                      />
                  </div>
                </div>
                <div className="row py-4">
                  <div className="col-md-12">
                    <DropDownInput
                        placeholder="Select range"                  
                        form={formik}
                        values={formik.values.additional_info?.est_supported_students}
                        onChange={formik.handleChange}
                        name={'additional_info.est_supported_students'}
                        label={'Approximate number of students you support'}
                        labelClass="block text-sm font-medium text-gray-700 mb-2"
                        labelCustom={(<span className="text-gray-500 font-normal">(optional)</span>)}
                        option={supportedStudentOptions}
                        
                    />
                  </div>
                </div>


                    <div className="pt-4">
                        <button 
                            type="button" 
                            className="w-full bg-gradmap-blue hover:bg-gradmap-navy text-white font-semibold py-4 rounded-lg transition-all duration-200 shadow-lg shadow-blue-500/30 hover:shadow-xl hover:shadow-blue-600/40 mb-3"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                formik.handleSubmit();
                              }}
                        >
                            Go to counselor dashboard
                        </button>
                        
                         <button 
                            type="button" 
                            className="w-full bg-white hover:bg-gray-50 text-gray-700 font-medium py-4 rounded-lg border-2 border-gray-300 hover:border-gray-400 transition-all duration-200"
                            onClick={handleSkip}
                        > 
                            I'll add students later
                        </button>
                    </div>

                <div className="mt-8 pt-6 border-t border-gray-200">
                    <div className="bg-blue-50 rounded-lg p-4">
                        <div className="flex items-start space-x-3">
                            <div className="flex-shrink-0">
                                <i className="text-gradmap-blue text-lg mt-0.5" data-fa-i2svg=""><svg className="svg-inline--fa fa-circle-info" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-info" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"></path></svg></i>
                            </div>
                            <div className="text-sm text-gray-700">
                                <p className="font-medium mb-1">Your workspace is ready to use</p>
                                <p>You can always add student information, customize settings, and invite colleagues later from your dashboard.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="text-center mt-6">
                <p className="text-sm text-gray-500">
                    Need help getting started? 
                    <a  href="https://docs.gradmap.com/en" target="_blank" rel="noreferrer" className="ml-1 text-gradmap-blue hover:text-gradmap-navy font-medium">View our counselor guide</a>
                </p>
            </div>
        </div>
    </div>
    );
};


export default FormCounselorSetup;